export const EMBED_CLASS_NAME = 'h-full min-h-149'
